import axios from "axios";

export const sriSyncJobApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/sri-sync-job`,
  headers: { "Content-Type": "application/json" },
});